module.exports = __webpack_public_path__ + "static/media/backend.6578619b.jpg";